document.addEventListener('DOMContentLoaded', function () {
  var galleryEl = document.querySelector('.ugc-gallery__inner');
  if (!galleryEl) return;

  function escapeHtml(str) {
    if (str == null || str === '') return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(str) {
    return escapeHtml(str).replace(/'/g, '&#39;');
  }

  function formatPrice(price) {
    var numericPrice;
    if (typeof price === 'string') {
      numericPrice = parseFloat(price.replace(/[^\d,.-]/g, '').replace(',', '.'));
    } else {
      numericPrice = Number(price);
    }
    if (isNaN(numericPrice)) return '';
    if (numericPrice >= 1000) numericPrice = numericPrice / 100;
    var currency = (Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(numericPrice);
  }

  function featuredImageSrc(fi) {
    if (!fi) return '';
    if (typeof fi === 'string') return fi;
    if (typeof fi === 'object' && fi.src) return fi.src;
    return '';
  }

  function getRealGalleryItems() {
    return Array.from(document.querySelectorAll('.ugc-gallery__item'));
  }

  function setButtonDisabledState(btn, disabled) {
    if (!btn) return;
    btn.classList.toggle('is-disabled', disabled);
    btn.setAttribute('aria-disabled', String(disabled));
    btn.disabled = disabled;
  }

  function toggleVideoPlayback(item, play) {
    var video = item.querySelector('video');
    var playIcon = item.querySelector('.play-icon .play');
    var pauseIcon = item.querySelector('.play-icon .pause');

    if (video) {
      try {
        if (play) {
          video.play();
        } else {
          video.pause();
          video.currentTime = 0;
        }
      } catch (err) {}
    }

    if (playIcon) playIcon.style.display = play ? 'none' : 'block';
    if (pauseIcon) pauseIcon.style.display = play ? 'block' : 'none';
  }

  var flkty = new Flickity(galleryEl, {
    cellAlign: 'left',
    contain: true,
    wrapAround: false,
    prevNextButtons: false,
    pageDots: false,
    draggable: true,
    cellSelector: '.ugc-gallery__item',
    groupCells: true
  });

  var prevBtn = galleryEl.parentNode.querySelector('.flickity-prev');
  var nextBtn = galleryEl.parentNode.querySelector('.flickity-next');

  function updateArrowState() {
    setButtonDisabledState(prevBtn, flkty.selectedIndex === 0);
    setButtonDisabledState(nextBtn, flkty.selectedIndex >= flkty.slides.length - 1);
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { flkty.previous(); });
  if (nextBtn) nextBtn.addEventListener('click', function () { flkty.next(); });

  flkty.on('select', updateArrowState);
  flkty.on('ready', updateArrowState);
  updateArrowState();

  galleryEl.addEventListener('mouseenter', function (e) {
    var item = e.target.closest('.ugc-gallery__item');
    if (item) toggleVideoPlayback(item, true);
  }, true);

  galleryEl.addEventListener('mouseleave', function (e) {
    var item = e.target.closest('.ugc-gallery__item');
    if (item) toggleVideoPlayback(item, false);
  }, true);

  var popup = document.getElementById('galleryPopup');
  var popupImage = document.getElementById('popupImage');
  var popupShopTheLook = document.getElementById('cointainer-ShopTheLook');
  var closeBtn = document.querySelector('.gallery-popup-close');
  var popupSubheadingContainer = document.getElementById('popupSubheadingContainer');
  var popupSubheading = document.getElementById('popupSubheading');
  var popupPrevBtn = document.getElementById('prevButton');
  var popupNextBtn = document.getElementById('nextButton');

  var currentIndex = -1;
  var _mediaLoadToken = 0;
  var _popupVideo = document.getElementById('popupVideo');

  function resetPopupMedia() {
    popupImage.style.display = 'none';
    popupImage.removeAttribute('src');
    popupImage.removeAttribute('srcset');
    popupImage.removeAttribute('sizes');
    popupImage.style.maxWidth = '';
    popupImage.style.height = '';

    try { _popupVideo.pause(); } catch (e) {}

    var fresh = document.createElement('video');
    fresh.id = 'popupVideo';
    fresh.setAttribute('controls', '');
    fresh.setAttribute('autoplay', '');
    fresh.setAttribute('playsinline', '');
    fresh.setAttribute('webkit-playsinline', '');
    fresh.muted = false;
    fresh.style.display = 'none';

    if (_popupVideo.parentNode) {
      _popupVideo.parentNode.replaceChild(fresh, _popupVideo);
    }
    _popupVideo = fresh;
  }

  function loadPopupVideo(item, token) {
    var videoElement = item.querySelector('video');
    if (!videoElement) return false;

    var resolvedSrc = videoElement.currentSrc || '';
    var sources = Array.from(videoElement.querySelectorAll('source'));

    if (resolvedSrc) {
      _popupVideo.src = resolvedSrc;
    } else {
      sources.forEach(function (source) {
        var s = document.createElement('source');
        s.setAttribute('src', source.getAttribute('src'));
        s.setAttribute('type', source.getAttribute('type') || '');
        _popupVideo.appendChild(s);
      });
    }

    _popupVideo.muted = false;
    _popupVideo.style.display = 'block';

    var playAttempted = false;
    function attemptPlay() {
      if (playAttempted || token !== _mediaLoadToken) return;
      playAttempted = true;
      _popupVideo.play().catch(function () {});
    }

    ['loadedmetadata', 'canplay', 'canplaythrough'].forEach(function (evt) {
      _popupVideo.addEventListener(evt, attemptPlay, { once: true });
    });

    setTimeout(function () {
      if (token !== _mediaLoadToken) return;
      attemptPlay();
    }, 800);

    _popupVideo.load();
    return true;
  }

  function loadPopupImage(item, token) {
    var imageElement = item.querySelector('img');
    if (!imageElement) return false;

    var imgSrc = imageElement.getAttribute('data-src') ||
      imageElement.getAttribute('data-lazy-src') ||
      imageElement.getAttribute('src') || '';
    var imgSrcset = imageElement.getAttribute('data-srcset') ||
      imageElement.getAttribute('srcset') || '';
    if (!imgSrc) return false;

    var tempImg = new Image();
    tempImg.onload = function () {
      if (token !== _mediaLoadToken) return;
      if (imgSrcset) {
        popupImage.setAttribute('srcset', imgSrcset);
        popupImage.setAttribute('sizes', '(max-width: 768px) 100vw, 50vw');
      } else {
        popupImage.removeAttribute('srcset');
        popupImage.removeAttribute('sizes');
      }
      popupImage.src = imgSrc;
      popupImage.style.display = 'block';
      popupImage.style.width = '100%';
      popupImage.style.maxWidth = '100%';
      popupImage.style.height = 'auto';
    };
    tempImg.onerror = function () {
      if (token !== _mediaLoadToken) return;
      popupImage.src = imgSrc;
      popupImage.style.display = 'block';
      popupImage.style.width = '100%';
      popupImage.style.maxWidth = '100%';
      popupImage.style.height = 'auto';
    };
    tempImg.src = imgSrc;
    return true;
  }

  function updatePopupSubheading(item) {
    var subheadingElement = item.querySelector('.subheading');
    if (subheadingElement && subheadingElement.textContent) {
      popupSubheading.textContent = subheadingElement.textContent;
      popupSubheadingContainer.style.display = 'flex';
    } else {
      popupSubheadingContainer.style.display = 'none';
    }
  }

  function parseProductData(item) {
    var jsonEl = item.querySelector('script.ugc-gallery__products-json');
    if (!jsonEl || !jsonEl.textContent) return [];

    var data;
    try {
      data = JSON.parse(jsonEl.textContent.trim());
    } catch (error) {
      return [];
    }

    if (Array.isArray(data)) return data;
    if (data && typeof data === 'object') return [data];
    return [];
  }

  function buildProductCard(product) {
    var productImage = featuredImageSrc(product.featured_image);
    var productTitle = product.title || '';
    var rawPrice = product.price != null ? product.price : product.price_min;
    var productPrice = rawPrice != null && rawPrice !== '' ? formatPrice(rawPrice) : '';
    var productUrl = product.url || ('/products/' + product.handle);

    return (
      '<div class="product-backdrop" data-url="' + escapeAttr(productUrl) + '" tabindex="0">' +
        '<div class="product-item">' +
          '<div class="image"><img src="' + escapeAttr(productImage) + '" alt="' + escapeAttr(productTitle) + '"></div>' +
          '<div class="content">' +
            '<p class="title">' + escapeHtml(productTitle) + '</p>' +
            '<p class="price">' + escapeHtml(productPrice) + '</p>' +
            '<a href="' + escapeAttr(productUrl) + '" class="btn">View Product</a>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function updateShopTheLook(item) {
    popupShopTheLook.innerHTML = '<p class="h5">Shop the Look</p><div class="shop-the-look-container"></div>';
    var container = popupShopTheLook.querySelector('.shop-the-look-container');
    var products = parseProductData(item);

    products.forEach(function (product) {
      if (!product || !product.handle) return;
      container.insertAdjacentHTML('beforeend', buildProductCard(product));
    });

    container.querySelectorAll('.product-backdrop').forEach(function (backdrop) {
      function navigate() {
        var url = backdrop.getAttribute('data-url');
        if (url) window.location.href = url;
      }
      backdrop.addEventListener('click', function (e) {
        if (!e.target.closest('.btn')) navigate();
      });
      backdrop.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') navigate();
      });
    });
  }

  function updatePopupContent(index) {
    var item = getRealGalleryItems()[index];
    if (!item) return;

    var token = ++_mediaLoadToken;
    resetPopupMedia();

    if (!loadPopupVideo(item, token)) {
      loadPopupImage(item, token);
    }

    updatePopupSubheading(item);
    updateShopTheLook(item);
  }

  function updatePopupNavButtons() {
    var galleryItems = getRealGalleryItems();
    setButtonDisabledState(popupPrevBtn, currentIndex <= 0);
    setButtonDisabledState(popupNextBtn, currentIndex >= galleryItems.length - 1);
  }

  function navigatePopup(direction) {
    var galleryItems = getRealGalleryItems();
    var newIndex = currentIndex + direction;
    if (newIndex < 0 || newIndex >= galleryItems.length) return;
    currentIndex = newIndex;
    updatePopupContent(currentIndex);
    updatePopupNavButtons();
    flkty.select(currentIndex);
  }

  function closePopup() {
    popup.style.display = 'none';
    resetPopupMedia();
  }

  flkty.on('staticClick', function (event, pointer, cellElement) {
    if (!cellElement) return;
    var idx = getRealGalleryItems().indexOf(cellElement);
    if (idx === -1) return;
    currentIndex = idx;
    updatePopupContent(currentIndex);
    popup.style.display = 'flex';
    updatePopupNavButtons();
  });

  closeBtn.addEventListener('click', closePopup);
  window.addEventListener('click', function (event) {
    if (event.target === popup) closePopup();
  });

  if (popupPrevBtn) popupPrevBtn.addEventListener('click', function () { navigatePopup(-1); });
  if (popupNextBtn) popupNextBtn.addEventListener('click', function () { navigatePopup(1); });
});
